import { axios, API } from './config';

export const equipmentAPI = {
  getAll: async (category = null) => {
    const params = category ? { category } : {};
    const response = await axios.get(`${API}/equipment`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/equipment/${id}`);
    return response.data;
  },
  
  getForMenu: async (menuId) => {
    const response = await axios.get(`${API}/equipment/for-menu/${menuId}`);
    return response.data;
  },
  
  create: async (equipmentData) => {
    const response = await axios.post(`${API}/equipment`, equipmentData);
    return response.data;
  },
  
  update: async (id, equipmentData) => {
    const response = await axios.put(`${API}/equipment/${id}`, equipmentData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/equipment/${id}`);
    return response.data;
  }
};
